import { createStore } from 'satcheljs';
export default createStore('adsPrefsOptionStore', {
    allowConsent: null,
    allowAccess: null,
    allowAdSelection: null,
    allowContentSelection: null,
    allowMeasurement: null,
    allowPersonalization: null,
});
//# sourceMappingURL=getStore.js.map